import { useEffect, useState } from 'react';
import { useMsal } from 'src/auth/firebaseMsalCompat';
import { useErrorBoundary } from 'react-error-boundary';
import axios from 'axios';

import { loginRequest } from '../../config/authConfig';
import { getApiHost } from '../../utils/getApiHost';
import { useFirebaseAuth } from '../../auth/FirebaseAuthContext';

export const useProjectList = (isAuthenticated: boolean) => {
  const [statusLoading, setStatusLoading] = useState(false);
  const [projectList, setProjectList] = useState<any>([]);
  const [error, setError] = useState<Error | null>(null);
  const { instance, inProgress } = useMsal();
  const { showBoundary } = useErrorBoundary();
  const { user } = useFirebaseAuth();
  const uid = isAuthenticated && user && !user.isAnonymous ? user.uid : null;

  useEffect(() => {
    if (inProgress !== 'none') return;

    if (!isAuthenticated || !uid) {
      setProjectList([]);
      setStatusLoading(false);
      setError(null);
      return;
    }

    let cancelled = false;
    // Don't keep the previous account's projects on screen while this loads.
    setProjectList([]);
    setError(null);
    setStatusLoading(true);

    const fetchProjectList = async () => {
      try {
        const authResult = await instance.acquireTokenSilent({
          ...loginRequest,
        });

        const apiUrl = getApiHost();
        const response = await axios.get(`${apiUrl}/project/list`, {
          headers: {
            Authorization: `Bearer ${authResult.idToken}`,
          },
        });

        if (!cancelled) setProjectList(response.data);
      } catch (err: any) {
        if (cancelled) return;
        setError(err);
        showBoundary(err);
      } finally {
        if (!cancelled) setStatusLoading(false);
      }
    };

    fetchProjectList();

    return () => {
      cancelled = true;
    };
  }, [instance, isAuthenticated, inProgress, showBoundary, uid]);

  return {
    projectList,
    statusLoading,
    error, // Now exposing the error state
    setProjectList,
  };
};
